import { Navigate, Route, Routes } from 'react-router-dom';
import HomePage from './pages/HomePage';
import FlightResultsPage from './pages/FlightResultsPage';
import HotelResultsPage from './pages/HotelResultsPage';
import CarResultsPage from './pages/CarResultsPage';
import PackageResultsPage from './pages/PackageResultsPage';
import CruiseResultsPage from './pages/CruiseResultsPage';
import MyBookingsPage from './pages/MyBookingsPage';
import SupportPage from './pages/SupportPage';
import AboutPage from './pages/AboutPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsPage from './pages/TermsPage';
import CookiePolicyPage from './pages/CookiePolicyPage';
import ServiceFeesPage from './pages/ServiceFeesPage';
import PostTicketingFeesPage from './pages/PostTicketingFeesPage';
import CancellationRefundPage from './pages/CancellationRefundPage';
import PriceMatchPromisePage from './pages/PriceMatchPromisePage';
import FulfillmentPolicyPage from './pages/FulfillmentPolicyPage';
import AdvertiserDisclosurePage from './pages/AdvertiserDisclosurePage';
import FareDisclosurePolicyPage from './pages/FareDisclosurePolicyPage';
import NotFoundPage from './pages/NotFoundPage';
import BookPage from './pages/BookPage';
import FixedCallBar from './components/FixedCallBar';
import MobileSupportPopup from './components/MobileSupportPopup';
import './flights-scoped.css';
import './components/PhoneCta.css';
import './components/CatchyHooksSection.css';
import './components/CallAttractionSections.css';
import './components/AboutEditorialCta.css';
import './components/Footer.css';
import './components/MobileSupportPopup.css';

/**
 * Isolated FareNodex-style flight experience for Fast Fares.
 * Mounted only under /flight/* — dummy data only, no live APIs.
 * Not linked from the main car rental site.
 */
export default function FlightApp() {
  return (
    <div className="fn-root">
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="search/flights" element={<FlightResultsPage />} />
        <Route path="search/hotels" element={<HotelResultsPage />} />
        <Route path="search/cars" element={<CarResultsPage />} />
        <Route path="search/packages" element={<PackageResultsPage />} />
        <Route path="search/cruises" element={<CruiseResultsPage />} />
        <Route path="book/:type" element={<BookPage />} />
        <Route path="bookings" element={<MyBookingsPage />} />
        <Route path="support" element={<SupportPage />} />
        <Route path="contact" element={<Navigate to="/flight/support" replace />} />
        <Route path="about" element={<AboutPage />} />
        <Route path="privacy" element={<PrivacyPolicyPage />} />
        <Route path="terms" element={<TermsPage />} />
        <Route path="cookies" element={<CookiePolicyPage />} />
        <Route path="service-fees" element={<ServiceFeesPage />} />
        <Route path="post-ticketing-fees" element={<PostTicketingFeesPage />} />
        <Route path="cancellation-refund" element={<CancellationRefundPage />} />
        <Route path="price-match" element={<PriceMatchPromisePage />} />
        <Route path="fulfillment-policy" element={<FulfillmentPolicyPage />} />
        <Route path="advertiser-disclosure" element={<AdvertiserDisclosurePage />} />
        <Route path="fare-disclosure" element={<FareDisclosurePolicyPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <MobileSupportPopup />
      <FixedCallBar />
    </div>
  );
}
